import { OvertimeComponent } from "../../components";

export default function OvertimeApprovalPage() {
  return <OvertimeComponent.OvertimeApprovalList />;
}
